import { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import 'react-datepicker/dist/react-datepicker.css';
import { Button } from 'primereact/button';

registerLocale('es', es);

function CaptureService() {
  const [serviceNumber, setServiceNumber] = useState('');
  const [drivers, setDrivers] = useState([]);
  const [driverId, setDriverId] = useState('');
  const [vehicles, setVehicles] = useState([]);
  const [vehicleId, setVehicleId] = useState('');
  const [purchaseDate, setPurchaseDate] = useState(null);
  const [zones, setZones] = useState([]);
  const [zoneId, setZoneId] = useState('');
  const [price, setPrice] = useState('');
  const [flightNumber, setFlightNumber] = useState('');
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [vehicleTypeId, setVehicleTypeId] = useState('');
  const [passengers, setPassengers] = useState('');
  const [serviceTypeId, setServiceTypeId] = useState('CD-A');
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [paymentMethodId, setPaymentMethodId] = useState('10');
  const [salesChannels, setSalesChannels] = useState([]);
  const [salesChannelId, setSalesChannelId] = useState('3');

  const onAddClick = async () => {
    const missingFields = [];
    if (!serviceNumber) missingFields.push('No. de servicio');
    if (!driverId) missingFields.push('Conductor');
    if (!vehicleId) missingFields.push('Vehículo');
    if (!purchaseDate) missingFields.push('Fecha de compra');
    if (!zoneId) missingFields.push('Zona');
    if (price === '') missingFields.push('Precio');
    if (!vehicleTypeId) missingFields.push('Tipo de vehículo');
    if (!serviceTypeId) missingFields.push('Tipo de servicio');
    if (!paymentMethodId) missingFields.push('Forma de pago');
    if (!salesChannelId) missingFields.push('Canal de venta');

    if (missingFields.length > 0) {
      window.alert(`Faltan campos obligatorios:\n- ${missingFields.join('\n- ')}`);
      return;
    }

    const payload = {
      orderNumber: serviceNumber || null,
      paymentTypeId: paymentMethodId || null,
      price: price === '' ? null : Number(price),
      flightNo: flightNumber || null,
      serviceType: serviceTypeId || null,
      vehicleTypeId: vehicleTypeId || null,
      zoneId: zoneId || null,
      driverId: driverId || null,
      vehicleId: vehicleId || null,
      purchaseDate: purchaseDate ? purchaseDate.getTime() : null,
      passengersNo: passengers === '' ? null : Number(passengers),
      dataOriginId: salesChannelId || null
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/order/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const data = await response.json().catch(() => null);

      if (!response.ok) {
        window.alert(`Error al crear servicio (HTTP ${response.status}).`);
        return;
      }

      if (data && data.responseCode && data.responseCode !== 'OK') {
        window.alert(`Error al crear servicio: ${data.responseMessage || 'Respuesta inválida.'}`);
        return;
      }

      window.alert('Servicio creado correctamente.');
      setServiceNumber('');
      setDriverId('');
      setVehicleId('');
      setPurchaseDate(null);
      setZoneId('');
      setPrice('');
      setFlightNumber('');
      setVehicleTypeId('');
      setPassengers('');
      setServiceTypeId('CD-A');
      setPaymentMethodId('');
      setSalesChannelId('3');
    } catch (error) {
      window.alert(`Error al crear servicio: ${error?.message || error}`);
    }
  };

  useEffect(() => {
    getDrivers();
    getVehicles();
    getVehicleTypes();
    getZones();
    getPaymentMethods();
    getSalesChannels();
  }, []);

  const getDrivers = () => {
    fetch(`${process.env.REACT_APP_API_URL}/driver/cmb`)
      .then(response => response.json())
      .then(data => {
        if (data.responseCode === 'OK') {
          const _drivers = data.responseObject;
          setDrivers(_drivers);
        }
      });
  };

  const getVehicles = () => {
    fetch(`${process.env.REACT_APP_API_URL}/vehicle/cmb?generic=false`)
      .then(response => response.json())
      .then(data => {
        if (data.responseCode === 'OK') {
          const _vehicles = data.responseObject;
          setVehicles(_vehicles);
        }
      });
  };

  const getVehicleTypes = () => {    
    fetch(`${process.env.REACT_APP_API_URL}/vehicleType/cmb?generic=false`)
      .then(response => response.json())
      .then(data => {
        if (data.responseCode === 'OK') {
          setVehicleTypes(data.responseObject);          
        } else {
          console.warn('CaptureService: getVehicleTypes: error: data:', data);
        }        
      });
  };  

  const getZones = () => {
    fetch(`${process.env.REACT_APP_API_URL}/zone/cmb`)
      .then(response => response.json())
      .then(data => {
        if (data.responseCode === 'OK') {
          setZones(data.responseObject);
        }
      });
  };

  const getPaymentMethods = () => {
    fetch(`${process.env.REACT_APP_API_URL}/paymentType/cmb`)
      .then(response => response.json())
      .then(data => {
        if (data.responseCode === 'OK') {
          setPaymentMethods(data.responseObject);
        }
      });
  };

  const getSalesChannels = () => {
    fetch(`${process.env.REACT_APP_API_URL}/dataOrigin/cmb`)
      .then(response => response.json())
      .then(data => {
        if (data.responseCode === 'OK') {
          setSalesChannels(data.responseObject);
        }
      });
  };

  return (
    <article>
      <Row>
        <Col>
          <h1 className="app-font">Captura de Servicio</h1>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <div className="card">
            <div className="card-body p-3">
              <table className="table table-sm table-bordered table-striped align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th className="text-start w-25">Campo</th>
                    <th className="text-start">Valor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th className="text-start w-25">No. de servicio</th>
                    <td>
                      <Form.Control
                        type="text"
                        value={serviceNumber}
                        onChange={(e) => setServiceNumber(e.target.value)}
                        maxLength={12}
                        style={{ width: '12ch' }}
                        placeholder="Ingresa el número"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th className="text-start w-25">Conductor</th>
                    <td>
                      <Form.Select
                        value={driverId}
                        onChange={(e) => setDriverId(e.target.value)}
                        style={{ width: '50ch' }}>
                        <option value="">Selecciona un conductor</option>
                        {drivers.map((driver) => (
                          <option key={driver.driverId} value={driver.driverId}>
                            {driver.name}
                          </option>
                        ))}
                      </Form.Select>
                    </td>
                  </tr>
                  <tr>
                    <th className="text-start w-25">Vehículo</th>
                    <td>
                      <Form.Select
                        value={vehicleId}
                        onChange={(e) => setVehicleId(e.target.value)}
                        style={{ width: '50ch' }}>
                        <option value="">Selecciona un vehículo</option>
                        {vehicles.map((vehicle) => (
                          <option key={vehicle.vehicleId} value={vehicle.vehicleId}>
                            {vehicle.description}
                          </option>
                        ))}
                      </Form.Select>
                    </td>
                  </tr>
                  <tr>
                    <th className="text-start w-25">Fecha de compra</th>
                    <td>
                      <DatePicker
                        selected={purchaseDate}
                        onChange={(date) => setPurchaseDate(date)}
                        showTimeSelect
                        timeFormat="HH:mm"
                        timeIntervals={15}
                        dateFormat="dd/MM/yyyy HH:mm"
                        locale="es"
                        className="app_datepicker"
                        style={{ width: '12ch' }}
                        placeholderText="Selecciona fecha y hora"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th className="text-start w-25">Zona</th>
                    <td>
                      <Form.Select
                        value={zoneId}
                        onChange={(e) => setZoneId(e.target.value)}
                        style={{ width: '50ch' }}>
                        <option value="">Selecciona una zona</option>
                        {zones.map((zone) => (
                          <option key={zone.zoneId} value={zone.zoneId}>
                            {zone.description}
                          </option>
                        ))}
                      </Form.Select>
                    </td>
                  </tr>
                  <tr>
                    <th className="text-start w-25">Precio</th>
                    <td>
                      <Form.Control
                        type="number"
                        step="0.01"
                        value={price}
                        onChange={(e) => setPrice(e.target.value)}
                        style={{ width: '12ch' }}
                        placeholder="0.00"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th className="text-start w-25">Vuelo</th>
                    <td>
                      <Form.Control
                        type="text"
                        value={flightNumber}
                        onChange={(e) => setFlightNumber(e.target.value)}
                        maxLength={10}
                        style={{ width: '12ch' }}
                        placeholder="Ingresa el vuelo"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th className="text-start w-25">Tipo de vehículo</th>
                    <td>
                      <Form.Select
                        value={vehicleTypeId}
                        onChange={(e) => setVehicleTypeId(e.target.value)}
                        style={{ width: '50ch' }}>
                        <option value="">Selecciona el tipo</option>
                        {vehicleTypes.map((vehicleType) => (
                          <option key={vehicleType.vehicleTypeId} value={vehicleType.vehicleTypeId}>
                            {vehicleType.description}
                          </option>
                        ))}
                      </Form.Select>
                    </td>
                  </tr>
                  <tr>
                    <th className="text-start w-25">Número de pasajeros</th>
                    <td>
                      <Form.Control
                        type="number"
                        min="0"
                        step="1"
                        value={passengers}
                        onChange={(e) => setPassengers(e.target.value)}
                        style={{ width: '12ch' }}
                        placeholder="0"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th className="text-start w-25">Tipo de servicio</th>
                    <td>
                      <Form.Select
                        value={serviceTypeId}
                        onChange={(e) => setServiceTypeId(e.target.value)}
                        style={{ width: '50ch' }}>
                        <option value="CD-A">CD-A</option>
                        <option value="A-CD">A-CD</option>
                        <option value="CD-CD">CD-CD</option>
                      </Form.Select>
                    </td>
                  </tr>
                  <tr>
                    <th className="text-start w-25">Forma de pago</th>
                    <td>
                      <Form.Select
                        value={paymentMethodId}
                        onChange={(e) => setPaymentMethodId(e.target.value)}
                        style={{ width: '50ch' }}>
                        <option value="">Selecciona la forma de pago</option>
                        {paymentMethods.map((paymentMethod) => (
                          <option key={paymentMethod.paymentTypeId} value={paymentMethod.paymentTypeId}>
                            {paymentMethod.description}
                          </option>
                        ))}
                      </Form.Select>
                    </td>
                  </tr>
                  <tr>
                    <th className="text-start w-25">Canal de venta</th>
                    <td>
                      <Form.Select
                        value={salesChannelId}
                        onChange={(e) => setSalesChannelId(e.target.value)}
                        style={{ width: '50ch' }}>
                        <option value="">Selecciona el canal</option>
                        {salesChannels.map((salesChannel) => (
                          <option key={salesChannel.dataOriginId} value={salesChannel.dataOriginId}>
                            {salesChannel.description}
                          </option>
                        ))}
                      </Form.Select>
                    </td>
                  </tr>
                  <tr>
                    <th className="text-start w-25"></th>
                    <td>
                      <Button
                        className="p-button-raised p-button-sm"
                        label="Agregar"
                        aria-label="Agregar"
                        onClick={onAddClick}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Col>
      </Row>
    </article>
  );
}

export default CaptureService;
